export const APP_VERSION: string = typeof __APP_VERSION__ === 'string' ? __APP_VERSION__ : '1.0.0';
export const API_BASE = '/api/v1';
export const IS_DEV = import.meta.env.DEV;
